(() => {
  if (window.cpDeliveryRouterInstalled) return;
  window.cpDeliveryRouterInstalled = true;
  let adding = false;
  const root = window.Shopify?.routes?.root || "/";
  const destination = `${root}cart?view=delivery`;
  document.addEventListener(
    "click",
    async (event) => {
      const button = event.target.closest("[data-cp-buy-now], [data-cp-cart-checkout]");
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.disabled || adding) return;
      if (button.hasAttribute("data-cp-cart-checkout")) {
        const cartForm = button.form;
        if (!cartForm || !cartForm.reportValidity()) return;
        adding = true;
        button.disabled = true;
        const errorHost = document.createElement("p");
        errorHost.setAttribute("role", "alert");
        errorHost.dataset.cpCartError = "";
        document.querySelectorAll("[data-cp-cart-error]").forEach((el) => el.remove());
        try {
          const response = await fetch(`${root}cart/update.js`, {
            method: "POST",
            body: new FormData(cartForm),
            headers: { Accept: "application/json" },
            signal: AbortSignal.timeout(15000),
          });
          if (!response.ok) throw new Error("Cart update failed");
          await response.json();
          window.location.assign(destination);
        } catch {
          errorHost.textContent =
            "Не успяхме да запазим количката. Проверете връзката и опитайте отново.";
          button.after(errorHost);
          button.disabled = false;
          adding = false;
        }
        return;
      }
      const form = button.closest("form");
      const nativeAdd = form?.querySelector('[name="add"]');
      if (!form || nativeAdd?.disabled || nativeAdd?.getAttribute("aria-disabled") === "true")
        return;
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      data.delete("return_to");
      data.delete("sections");
      data.delete("sections_url");
      if (!data.get("id")) return;
      adding = true;
      button.disabled = true;
      const oldText = button.textContent;
      button.textContent = "Добавяме продукта…";
      const container = form.closest("product-form");
      const oldAlert = form.querySelector("[data-cp-buy-error]");
      oldAlert?.remove();
      try {
        // No automatic retries: an ambiguous add may already have reached Shopify.
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          body: data,
          headers: { Accept: "application/json" },
          signal: AbortSignal.timeout(15000),
        });
        const result = await response.json();
        if (!response.ok)
          throw new Error(
            typeof result.description === "string"
              ? result.description
              : "Продуктът не може да бъде добавен.",
          );
        window.location.assign(destination);
      } catch (err) {
        const message =
          err.name === "TimeoutError" || err instanceof TypeError
            ? "Връзката прекъсна. Проверете количката, преди да добавите отново."
            : err.message;
        if (container?.handleErrorMessage) container.handleErrorMessage(message);
        else {
          const alert = document.createElement("p");
          alert.dataset.cpBuyError = "";
          alert.setAttribute("role", "alert");
          alert.textContent = message;
          form.append(alert);
        }
        adding = false;
        button.disabled = false;
        button.textContent = oldText;
      }
    },
    true,
  );
  new MutationObserver((records) => {
    for (const record of records) {
      const native = record.target;
      if (!native.matches?.('[name="add"]')) continue;
      const buy = native.closest("form")?.querySelector("[data-cp-buy-now]");
      if (buy && !adding)
        buy.disabled = native.disabled || native.getAttribute("aria-disabled") === "true";
    }
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ["disabled", "aria-disabled"],
  });
  window.addEventListener("pageshow", () => {
    adding = false;
    document.querySelectorAll("[data-cp-cart-checkout]").forEach((button) => {
      button.disabled = !button.form?.querySelector('[name="updates[]"]');
    });
    document.querySelectorAll("[data-cp-buy-now]").forEach((button) => {
      const nativeAdd = button.closest("form")?.querySelector('[name="add"]');
      button.disabled = Boolean(nativeAdd?.disabled);
      button.textContent = "Купете сега";
    });
  });
})();
